import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-add-supportive-services-included-confirmation',
    templateUrl: './add-supportive-services-included-confirmation.component.html',
    styleUrls: ['./add-supportive-services-included-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSupportiveServicesIncludedConfirmationComponent {
  attributes: any;
  newSupportiveServicesIncluded: string;
  constructor(
    public dialogRef: MatDialogRef<AddSupportiveServicesIncludedConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      attributes: any
    }
  ) {
    this.attributes = data.attributes;
    dialogRef.disableClose = true;
  }

  checkName(){
    let hasDuplicate = false;
    for(let i = 0; i < this.attributes.length; i++){
      if(this.attributes[i].name === this.newSupportiveServicesIncluded){
        hasDuplicate = true;
        break;
      }
    }
    return hasDuplicate;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
